import { Box } from '@mui/material';
import UPButton from 'components/button';
import { UPTanStackTableColumn } from 'components/tanstack-table';
import { TFunction } from 'i18next';
import {
  GENERAL__EDIT,
  PARITAIR_COMITE__DUTCH,
  PARITAIR_COMITE__ENGLISH,
  PARITAIR_COMITE__FRENCH,
} from 'translations/constants';
import { IParitairComite } from 'types/paritair-comite';

const getNumberIndent = (value: string): string => {
  const yySubcategory = value.substring(3, 5);
  const zzSubcategory = value.substring(5);
  if (!yySubcategory.match('00') && zzSubcategory.match('00')) return '20px';
  if (!zzSubcategory.match('00')) return '40px';
  return '0px';
};

export const buildParitairComiteColumns = (
  t: TFunction,
  onEdit: (row: IParitairComite) => void,
): UPTanStackTableColumn<IParitairComite>[] => [
  {
    id: 'number',
    header: 'Number',
    enableSorting: false,
    cell: ({ row }) => <Box sx={{ paddingLeft: getNumberIndent(row.number.toString()) }}>{row.number}</Box>,
  },
  { id: 'dutchName', header: t(PARITAIR_COMITE__DUTCH), accessorKey: 'dutchName' },
  { id: 'frenchName', header: t(PARITAIR_COMITE__FRENCH), accessorKey: 'frenchName' },
  { id: 'englishName', header: t(PARITAIR_COMITE__ENGLISH), accessorKey: 'englishName' },
  {
    id: 'actions',
    header: '',
    align: 'right',
    enableSorting: false,
    cell: ({ row }) => <UPButton text={t(GENERAL__EDIT)} outlined onClick={() => onEdit(row)} />,
  },
];
